import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const SubmissionAssignment = () => {
  //const [platforms, setPlatforms] = useState([]);
  //Sujay 9/6/2025 taking the platform from localstorage and fetching the data
  const PlatformID = localStorage.getItem("platformID");
  //const [selectedPlatformId, setSelectedPlatformId] = useState('');
  const [authors, setAuthors] = useState([]);
  const [selectedAuthorId, setSelectedAuthorId] = useState(null);
  const [submissions, setSubmissions] = useState([]);
  const [selectedSubmissionId, setSelectedSubmissionId] = useState(null);
  const [reviewers, setReviewers] = useState([]);
  const [selectedReviewerIds, setSelectedReviewerIds] = useState([]);
  //Sujay 11/6/2025 adding the variable to check the paper is original or not 
  const [isOriginal, setIsOriginal] = useState(false);
  const [originalReviewers, setOriginalReviewers] = useState([]);
  //for rejecting paper 
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [rejectSubmissionId, setRejectSubmissionId] = useState(null);
  const API = process.env.REACT_APP_API_BASE_URL;
  const platformId = localStorage.getItem('platformID');

  // PDF Viewer modal state
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [authorFilter, setAuthorFilter] = useState('all'); // 'all' or 'pending'


  //Sujay 9/6/2025 taking the platform from localstorage and fetching the data
useEffect(() => {
  axios
    .get(`${API}/api/subassignments/authors`, {
      params: { platformID: PlatformID }
    })
    .then(res => {
      console.log('Authors response:', res.data);
      setAuthors(res.data);
    })
    .catch(err => console.error('Authors error:', err));

  axios
    .get(`${API}/api/subassignments/reviewers/${PlatformID}`)
    .then(res => {
      console.log('Reviewers response:', res.data);
      setReviewers(res.data);
    })
    .catch(err => console.error('Reviewers error:', err));
}, [API, PlatformID]);


  // Fetch submissions when an author is selected
  useEffect(() => {
    if (selectedAuthorId) {
      axios.get(`${API}/api/subassignments/submissions/unassign/${selectedAuthorId}/${platformId}`)
        .then(res => setSubmissions(res.data))

        .catch(err => console.error(err));
    }
  }, [selectedAuthorId, API, platformId]);

  //sujay 11/6/2025 adding the function to check if original or not 
  const handleCheckOriginal = async (submissionID) => {
    try {
      const res = await axios.get(`${API}/api/subassignments/checkoriginal/${submissionID}`);
      setIsOriginal(res.data.isParent);

      const reviewerString = res.data.reviewers?.[0]?.ReviewerIDs || "";
      const reviewerArray = reviewerString
        .split(',')
        .filter(id => id.trim() !== "") // Remove empty strings if any
        .map(id => Number(id));

      setOriginalReviewers(reviewerArray);
    } catch (error) {
      console.error("Error checking original submission:", error);
      // Optional: handle error state or show a message to user
    }
  };

  // Modify the reject button handler to open modal:
  const openRejectModal = (submissionID) => {
    setRejectSubmissionId(submissionID);
    setRejectReason('');
    setShowRejectModal(true);
  };

  //reject funtion for derectly reject the paper
  const confirmRejectSubmission = async () => {
    if (!rejectReason.trim()) {
      alert("Please enter a reason for rejection.");
      return;
    }

    try {
      const res = await axios.post(`${API}/api/subassignments/rejectbyHost`, {
        submissionID: rejectSubmissionId,
        platformID: PlatformID,
        reason: rejectReason, // send the rejection reason
      });
      alert(res.data.message || "Submission rejected successfully.");
      setShowRejectModal(false);
      setRejectReason('');
      setRejectSubmissionId(null);

      // Refresh submissions list after rejection
      axios.get(`${API}/api/subassignments/submissions/unassign/${selectedAuthorId}/${platformId}`)
        .then(res => setSubmissions(res.data))
        .catch(err => console.error(err));

      // Reset selected submission
      setSelectedSubmissionId(null);
      setIsOriginal(false);
      setOriginalReviewers([]);

    } catch (error) {
      console.error("Error rejecting submission:", error);
      alert("Failed to reject submission.");
    }
  };

  // Submit handler
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedAuthorId || !selectedSubmissionId || (!isOriginal && originalReviewers.length === 0) || (isOriginal && selectedReviewerIds.length === 0) || !PlatformID) {
      alert('Please select all fields before submission.');
      return;
    }

    const reviewersToSubmit = isOriginal ? selectedReviewerIds : originalReviewers;

    axios.post(`${API}/api/subassignments/assign`, {
      AuthorID: selectedAuthorId,
      submissionID: selectedSubmissionId,
      ReviewerIDs: reviewersToSubmit,
      PlatformID: PlatformID
    }).then(res => {
      alert(res.data.message);
      window.location.reload();
      setSelectedAuthorId(null);
      setSelectedSubmissionId(null);
      setSelectedReviewerIds([]);
      setOriginalReviewers([]);
      setIsOriginal(false);
    }).catch(err => {
      alert('Error saving assignment');
      console.error(err);
    });
  };

  // Open PDF in modal function
  const openPdfModal = (fileName) => {
    setPdfUrl(`${API}/uploads/papers/${fileName}`);
    setShowPdfModal(true);
  };

  const closePdfModal = () => {
    setShowPdfModal(false);
    setPdfUrl('');
  };

  // Cancel reject modal
  const cancelReject = () => {
    setShowRejectModal(false);
    setRejectReason('');
    setRejectSubmissionId(null);
  };

  return (
    <div className="container my-4 ml-2">
      <div className="p-4 ">
        <h3 className="page-title mb-4">Assign Submission to Reviewers</h3>

        {/* Platform selection */}

        {/* sujay 9/6/2025 hiding the platformSelection part */}

        {/* <div className="mb-4">
          <label className="form-label fw-bold">Select Platform</label>
          <select className="form-select" value={selectedPlatformId} onChange={(e) => setSelectedPlatformId(e.target.value)}>
            <option value="">-- Select Platform --</option>
            {platforms.map(platform => (
              <option key={platform.PlatformID} value={platform.PlatformID}>
                {platform.PlatformName}
              </option>
            ))}
          </select>
        </div> */}

        <div className="mb-3">
  <label className="form-label fw-bold">Filter Authors:</label>
  <select
    className="form-select w-auto d-inline-block ms-2"
    value={authorFilter}
    onChange={(e) => setAuthorFilter(e.target.value)}
  >
    <option value="all">All</option>
    <option value="pending">Pending</option>
  </select>
</div>


        {/* Author selection */}
        {authors.length > 0 && (
          <div className="mb-4">
            <h5 className="text-secondary">Select Author</h5>
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Select</th>
                    <th>Author Name</th>
                    <th>Email</th>
                    <th>Unassigned Submissions</th>
                  </tr>
                </thead>
                <tbody>
                  {authors 
                    .filter(author => authorFilter === 'all' || (authorFilter === 'pending' && (author.unassignedSubmissionsCount ?? 0) > 0))
                  .map(author => (
                    <tr key={author.AuthorID}>
                      <td>
                        <input
                          type="radio"
                          name="author"
                          value={author.AuthorID}
                          checked={selectedAuthorId === author.AuthorID}
                          onChange={() => setSelectedAuthorId(author.AuthorID)}
                        />
                      </td>
                      <td>{author.AuthorName}</td>
                      <td>{author.EmailID}</td>
                      <td>{author.unassignedSubmissionsCount ?? 0}</td> 
                    </tr>
                  ))}
                </tbody>

              </table>
            </div>
          </div>
        )}

        {/* Submission selection */}
        {submissions.length > 0 ? (
          <div className="mb-4">
            <h5 className="text-secondary">Select Submission</h5>
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr><th>Select</th><th>Submission Title</th><th>Date</th><th>Actions</th></tr>
                </thead>
                <tbody>
                  {submissions.map(sub => (
                    <tr key={sub.submissionID}>
                      <td>
                        <input
                          type="radio"
                          name="submission"
                          value={sub.submissionID}
                          checked={selectedSubmissionId === sub.submissionID}
                          onChange={() => {
                            setSelectedSubmissionId(sub.submissionID)
                            //sujay 11/6/2025 added the code to check if original paper or not
                            handleCheckOriginal(sub.submissionID)
                          }}
                        />
                      </td>
                      <td>{sub.SubmissionTitle}</td>
                      <td>{new Date(sub.submissiondate).toLocaleDateString()}</td>
                      <td>
                        {/* Show PDF button */}
                        {sub.File && (
                          <button
                            className="btn btn-sm btn-outline-primary me-2"
                            onClick={() => openPdfModal(sub.File)}
                          >
                            View PDF
                          </button>
                        )}
                        {/* Reject button */}
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => openRejectModal(sub.submissionID)}
                        >
                          Reject
                        </button>

                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : <div className="alert alert-info fw-bold text-center mb-3 rounded shadow-sm" role="alert">
          This author does not have a paper to assign to a reviewer.
        </div>}

        {/* Reviewer selection */}
        {!isOriginal && reviewers.length > 0 && originalReviewers.length > 0 && (
          <div className="mb-4">
            <h5 className="text-secondary">Original Reviewers</h5>
            <ul className="list-group">
              {reviewers
                .filter(rev => originalReviewers.includes(rev.ReviewerID))
                .map(rev => (
                  <li key={rev.ReviewerID} className="list-group-item d-flex justify-content-between align-items-center">
                    <span>
                      <strong>{rev.ReviewerName}</strong> <small className="text-muted">({rev.EmailID})</small>
                    </span>
                  </li>
                ))}
            </ul>
          </div>
        )}

        {isOriginal && reviewers.length > 0 && (
          <div className="mb-4">
            <h5 className="text-secondary">Select Reviewers (max 3)</h5>
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Select</th><th>Reviewer Name</th><th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  {reviewers.map(rev => {
                    const id = rev.ReviewerID;
                    const checked = selectedReviewerIds.includes(id);
                    const disableUncheckable =
                      !checked && selectedReviewerIds.length >= 3;

                    return (
                      <tr key={id}>
                        <td>
                          <input
                            type="checkbox"
                            value={id}
                            checked={checked}
                            disabled={disableUncheckable}
                            onChange={() => {
                              setSelectedReviewerIds(prev =>
                                prev.includes(id)
                                  ? prev.filter(r => r !== id)
                                  : [...prev, id]
                              );
                            }}
                          />
                        </td>
                        <td>{rev.ReviewerName}</td>
                        <td>{rev.EmailID}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {selectedReviewerIds.length >= 3 && (
                <div className="text-danger mt-2">
                  You can select up to a maximum of 3 reviewers.
                </div>
              )}
            </div>
          </div>
        )}

        <button className="btn btn-primary" onClick={handleSubmit}>Assign</button>

        {/* PDF Viewer Modal */}
        {showPdfModal && (
          <div
            className="modal fade show"
            tabIndex="-1"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
            onClick={closePdfModal}
          >
            <div
              className="modal-dialog modal-xl modal-dialog-centered"
              onClick={(e) => e.stopPropagation()}
              style={{ maxHeight: '90vh', overflow: 'auto' }}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">PDF Viewer</h5>
                  <button type="button" className="btn-close" onClick={closePdfModal}></button>
                </div>
                <div className="modal-body" style={{ height: '80vh' }}>
                  <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                    <Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} />
                  </Worker>

                </div>
              </div>
            </div>
          </div>
        )}

        {/* Reject Submission Modal */}
        {showRejectModal && (
          <div
            className="modal fade show"
            tabIndex="-1"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
            onClick={cancelReject}
          >
            <div
              className="modal-dialog modal-dialog-centered"
              onClick={e => e.stopPropagation()}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Reject Submission</h5>
                  <button type="button" className="btn-close" onClick={cancelReject}></button>
                </div>
                <div className="modal-body">
                  <label htmlFor="rejectReason" className="form-label">
                    Reason for rejection:
                  </label>
                  <textarea
                    id="rejectReason"
                    className="form-control"
                    rows="4"
                    value={rejectReason}
                    onChange={e => setRejectReason(e.target.value)}
                    placeholder="Enter the reason for rejection..."
                  />
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={cancelReject}>
                    Cancel
                  </button>
                  <button className="btn btn-danger" onClick={confirmRejectSubmission}>
                    Reject
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default SubmissionAssignment;
